import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const USERS_USER_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/users',
        name: '::Menu:Users',
        parentName: '::Menu:UserManagement',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Users',
        order:3
      },
    ]);
  };
}
